import { defineMessages } from 'react-intl';

export default defineMessages({
  viewAllMenuItem: {
    id: 'viewAllMenuItem',
    defaultMessage: 'View all'
  }
});
